//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DateOptionRange from './date-option-range';

export default {
    components: {
        DateOptionRange: DateOptionRange
    },
    props: {
        labelDateOption: {
            type: String
        },
        restrictSixMonths: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            isOpen: false,
            isRange: false,
            today: this.$moment().clone(),
            sinceDate: null,
            toDate: null,
            monthYear: null,
            monthYearText: null
        };
    },

    computed: {
        isDirty: function isDirty() {
            return !!this.monthYear || !!this.sinceDate || !!this.toDate;
        },
        dates: function dates() {
            var _this = this;

            Array.apply(0, Array(12)).map(function (val, index) {
                _this.today.clone().add(index * -1, 'month').format('MMMM YYYY');
            });
        },
        selectedValue: function selectedValue() {
            this.monthYear || this.sinceDate + (this.toDate ? ' al ' + ("" + this.toDate) : void 0);
        }
    },
    methods: {
        clear: function clear() {
            this.monthYearText = null;
            this.emitInput();
            this.clearStore();
            this.sinceDate = this.toDate = this.monthYear = null;
        },
        selectRange: function selectRange() {
            this.$refs.rangeModal.open();
            this.isRange = true;
        },
        monthSelected: function monthSelected(date, index) {

            this.monthYear = this.moment().add(index * -1, 'month').format('MM-YYYY');
            this.monthYearText = date;
            this.sinceDate = null;
            this.toDate = null;
            this.emitInput();
        },
        rangeSelected: function rangeSelected(_ref) {
            var sinceDate = _ref.sinceDate,
                toDate = _ref.toDate;

            var monthsLength = this.$moment(new Date(toDate)).diff(this.$moment(new Date(sinceDate)), "months", true);

            this.sinceDate = sinceDate;
            this.toDate = toDate;
            if (sinceDate || toDate) {
                this.monthYear = this.monthYearText = null;
            }

            if (this.restrictSixMonths && monthsLength > 6) {
                alert("Por favor, elige un rango de fechas menor o igual a 6 meses");
                this.clear();
            }

            this.emitInput();
        },
        emitInput: function emitInput() {
            this.$emit('input', {
                sinceDate: this.sinceDate,
                toDate: this.toDate,
                monthYear: this.monthYear
            });
        },
        openDate: function openDate() {
            this.$emit('click');
        },
        clearStore: function clearStore() {
            var value = '';
            this.$store.commit('dashboard/filters/setAdmisionStartDate', value);
            this.$store.commit('dashboard/filters/admisionEndDate', value);
            this.$store.commit('dashboard/filters/setHighStartDate', value);
            this.$store.commit('dashboard/filters/setHighEndDate', value);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/date-option.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/date-option.vue
// module chunks = 0 5